import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import { FC } from 'react'

const Button: FC<LoadingButtonProps> = (props) => {
    return (
        <LoadingButton variant='contained' {...props} />
    )
}

export default Button;